import { useFavorites } from '@/lib/hooks/use-favorites';
import { cn } from '@/lib/utils';

export default function FavoriteButton({ contentId }: { contentId: string }) {
  // TODO: pass ID to useFavorites hook instead of looking up all favorites
  const { favorites, toggleFavorite } = useFavorites();
  const isFavorite = favorites[contentId];

  return (
    <button
      onClick={() => toggleFavorite(contentId)}
      className="absolute top-8 right-8 z-50 text-white hover:text-white/80 transition-colors cap-top-abs"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill={isFavorite ? 'currentColor' : 'none'}
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={cn('h-8 w-8', isFavorite && 'text-red-500')}
      >
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
      </svg>
    </button>
  );
}
